import { all, put, select, takeLatest } from 'redux-saga/effects';
import { requests, actions } from './reducer';
import { getInstallersListQuery } from './selector';

export function* fetchEffect({ payload }) {
  const actualQuery = yield select(getInstallersListQuery);
  const query = {
    ...actualQuery,
    ...payload,
  };
  yield put(requests.fetch({ query }));
}

export default function* () {
  yield all([takeLatest(actions.setFilter.type, fetchEffect)]);
}
